import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";

import MainHeader from "./components/MainHeader";
import MainFooter from "./components/MainFooter";
import MainSidebar from "./components/MainSidebar";
import { useBoardItem } from "../../hooks/useBoardItem";

const MainLayout = () => {
  const location = useLocation();
  const { useGetBoards } = useBoardItem();

  const [openSidebar, setOpenSidebar] = useState(false);

  useGetBoards();

  useEffect(() => {
    setOpenSidebar(false);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location.pathname]);

  return (
    <>
      <MainHeader setOpenSidebar={setOpenSidebar} />

      <MainSidebar openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} />

      <main className="main-layout">
        <Outlet />

        <button
          className="fixed bottom-6 right-6 lg:h-[60px] lg:w-[60px] h-12 w-12 bg-primary text-white rounded-md z-15 opacity-80 hover:opacity-100"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          <FontAwesomeIcon icon={faChevronUp} />
        </button>
      </main>

      <MainFooter />
    </>
  );
};

export default MainLayout;
